
import { Component, Vue, Watch } from "vue-property-decorator";
import { getLocalLanguage, isDisplayShow } from '@/utils/index'
import ProductionTable from './components/ProductionTable'
import './index.less'
import { TenantBizFieldServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { ProductionPlanServiceProxy } from "@/service-proxies/app-v2/coproduction.service-proxies";
import WorkOrder from '../production-plan/components/WorkOrder'
import MaterialRequirementList from '../production-plan/MaterialRequirementList/index'
import WorkMaterialList from '../production-plan/WorkMaterialList/index'
import WipDeliveryStatistics from '../production-plan/WipDeliveryStatistics/index'
import WipWarehousingStatistics from '../production-plan/WipWarehousingStatistics/index'
import QualityStatistics from './components/QualityStatistics'
import { getLocalStorage, removeLocalStorage, setLocalStorage } from "@/utils/storage";

const tenantBsp = new TenantBizFieldServiceProxy()
const ppsp = new ProductionPlanServiceProxy()

@Component({
  components: {
    ProductionTable,
    WorkOrder,
    MaterialRequirementList,
    WorkMaterialList,
    WipDeliveryStatistics,
    WipWarehousingStatistics,
    QualityStatistics
  }
})
export default class ProductionPlanV2 extends Vue {
  productionY = 300
  formY = 30
  resizeTimer = null
  searchDto:any = {
    typeId: "",
    filterPlus: false,
    planStatus: ["1", "2", "3", "4"],
    param: {},
    productInfo: '',
    code: ''
  }
  formTailLayout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };
  showColumns = [] // table展示columns
  productionList = [] //业务数据列表
  getproductionLoading = false //业务数据加载状态
  selectId = "" //业务数据选中Id
  currentPlan = {}
  pagination = {
    current: 1,
    pageSize: 25,
    total: 0
  }
  form = {} as any
  activeTabKey = "page_work_order"

  created(){
    const info = getLocalStorage('jobInfo')
    if(info){
      this.selectId = info.id
      this.searchDto.filterPlus = false
      this.form['code'] = info.code
      this.searchDto.code = info.code
      removeLocalStorage('jobInfo')
    }
    this.getTableColumn()

    function done(fn, delay_time){
      var start_time = null;
      return function(){
          var curr_time = +new Date();
          !start_time && (start_time = curr_time);
          if (curr_time- start_time >= delay_time){
              fn.apply(this, arguments);
              start_time = curr_time;
          }
      }
    }
    
    window.onresize = done(() => {
      this.getHeight();
    },100)

  }
  
  // 获取指定业务的字段列表
  async getTableColumn() {
    this.searchDto.typeId = this.$route.path[this.$route.path.length - 1]
    const Colums = await tenantBsp.getTenantBizField('plan', this.searchDto.typeId)
    this.showColumns = []
    if(Colums && Colums.length){
      this.showColumns = this.handleColumns(Colums)
      this.$nextTick(() =>{
        this.getList()
        this.getHeight()
      })
    }
  }

  handleColumns(productColums) {
    // 字段排序
    productColums.sort((a, b) => {
      return a.sort - b.sort
    })
    // 字段显隐
    let columns = []
    productColums.map(item => {
      if (isDisplayShow(item.isDisplay, 2)) {
        // 自定义字段：产品类型
        const temp: any = {
          title: item.title,
          key: item.code,
          dataIndex: item.code,
          ellipsis: true,
        }
        if (temp.key === 'code') {
          columns.push(temp)
        }
      }
    })
    columns.push({
      title: this.$t('page_quality_product_information'),
      key: 'productInfo',
      dataIndex: 'productInfo',
      ellipsis: true
    })
    return columns
  }

  // 拖拽行改变
  changeY(){
    if(this.resizeTimer){
      clearTimeout(this.resizeTimer);
    }
    this.resizeTimer = setTimeout(function(){
      const materialdDiv = document.getElementById('production-table')
      this.productionY = materialdDiv.clientHeight
      const materialTableBody: any = document.querySelector('#production-table .ant-table-body')
      if(materialTableBody){
        materialTableBody.style.maxHeight = (this.productionY - 70) + 'px'
      }
      
    },100)
  }

  getHeight(){
    // console.log('aaaaaaaaa')
    const formDiv = document.getElementById('production-plan-search')
    this.formY = formDiv.clientHeight + 8
    const productionDiv = document.getElementById('production-plan-left')

    let pageHeight = document.getElementsByClassName('ant-pagination')[0].clientHeight
    // if(pageHeight < 50) {
    //   pageHeight = 0;
    // }

    this.productionY = productionDiv.clientHeight - this.formY - 90 - pageHeight
  }

  // 查询
  search(){
    this.searchDto.filterPlus = false
    this.searchDto.code = this.form.code
    this.searchDto.productInfo  = this.form.productInfo
    this.pagination.current = 1
    this.getList()
  }
  
  // 重置
  reast(){
    this.form = {}
  }

  // 获取业务数据
  getList(){
    this.productionList = []
    ppsp.page(this.pagination.current,this.searchDto,this.pagination.pageSize).then(res =>{
      this.productionList = res.records
      this.pagination.total = Number(res.total)
      if(res.records.length > 0) {
      if(this.selectId === "" && res.total){
        this.changeBom(res.records[0])
      } else if(this.selectId != "" && res.total){
        const item = res.records.find(item => item.id === this.selectId)
        this.changeBom(item)
      }
    }else {
      this.currentPlan = {}
    }
    })
  }

  // 选中行操作
  changeBom(record){
    this.selectId = record.id
    this.currentPlan = record
  }

  handleTableChange(current,size){
    this.pagination.current = current
    this.pagination.pageSize = size
    this.selectId = ""
    this.getList()
  }

  load(){
    this.form = {}
    this.searchDto.filterPlus = false
    this.searchDto.param = {}
    this.pagination.current = 1
    this.selectId = ""
    this.getList()
  }

  changeTab(value){
    this.activeTabKey = value
  }

  render() {
    return (
      <div style="height: 100%;display: flex;">
        <div class="production-leeft">
          {this.showColumns.length ? <div id="production-plan-left">
            <a-form-model id="production-plan-search" label-col={this.formTailLayout.labelCol} wrapper-col={this.formTailLayout.wrapperCol}>
             {this.showColumns.map(res => {return (
                <a-form-model-item label={res.title}>
                  <a-input placeholder={res.title} style="width: 100%" v-model={this.form[res.key]} ></a-input>
                </a-form-model-item>)}
              )}
              <a-form-model-item wrapper-col={{ span: 15, offset: 9 }}>
                <a-button type="primary" onClick={() => this.search()} style="margin-right: 8px">{ this.$t('search') }</a-button>
                <a-button onClick={() => this.reast()}>{ this.$t('page_calendar_reset') }</a-button>
              </a-form-model-item>
            </a-form-model>
            <div id="production-table" style={{height: `calc(100% - 125px)`}}>
              <production-table
                columns={this.showColumns}
                scrollY={this.productionY}
                data={this.productionList}
                loading={this.getproductionLoading}
                selectId={this.selectId}
                current={this.pagination.current}
                pageSize={this.pagination.pageSize}
                total={this.pagination.total}
                onClickRow={reocrd => this.changeBom(reocrd)}
                onHandleTableChange={(current,size) => this.handleTableChange(current,size)}
              ></production-table>
            </div>
          </div> :
          <div
            class="empty"
            v-else
            style="height: 100%;width: 100%;display: flex;align-items: center;justify-content: center;"
          >
            <wm-empty text={this.$t('page_plan_config_tip')} />
          </div>}
        </div>
        <div v-resize={{ axis: 'x' }}></div>
        <div style="width: calc(100% - 408px);height100%;">
          <div id="production-info">            
            <a-tabs type="card" onChange={value => this.changeTab(value)}>
              <a-tab-pane key="page_work_order" tab={this.$t('page_work_order')}></a-tab-pane>
              <a-tab-pane v-acl={'page_plan_material_requirement_list' + '_' + this.searchDto.typeId} key="page_plan_material_requirement_list" tab={this.$t('page_plan_material_requirement_list')}></a-tab-pane>
              <a-tab-pane v-acl={'page_plan_material_consume' + '_' + this.searchDto.typeId} key="page_plan_material_consume" tab={this.$t('page_plan_material_consume')}></a-tab-pane>
              <a-tab-pane v-acl={'page_plan_wip_delivery_statistics' + '_' + this.searchDto.typeId} key="page_plan_wip_delivery_statistics" tab={this.$t('page_plan_wip_delivery_statistics')}></a-tab-pane>
              <a-tab-pane v-acl={'page_plan_wip_warehousing_statistics' + '_' + this.searchDto.typeId} key="page_plan_wip_warehousing_statistics" tab={this.$t('page_plan_wip_warehousing_statistics')}></a-tab-pane>
              <a-tab-pane v-acl={'page_quality_inspection_statistics' + '_' + this.searchDto.typeId} key="page_plan_quality_testing_statistics" tab={this.$t('page_job_plan_cont_quality_inspection_statistics')}></a-tab-pane>
            </a-tabs>
            <div class="production-info-show">
              {this.activeTabKey === 'page_work_order' ? <WorkOrder plan={this.currentPlan} /> : null}
              {this.activeTabKey === 'page_plan_material_requirement_list' ? <MaterialRequirementList plan={this.currentPlan}/> : null}
              {this.activeTabKey === 'page_plan_material_consume' ? <WorkMaterialList plan={this.currentPlan}/> : null}
              {this.activeTabKey === 'page_plan_wip_delivery_statistics' ? <WipDeliveryStatistics plan={this.currentPlan}/> : null}
              {this.activeTabKey === 'page_plan_wip_warehousing_statistics' ? <WipWarehousingStatistics plan={this.currentPlan}/> : null}
              {this.activeTabKey === 'page_plan_quality_testing_statistics' ? <QualityStatistics plan={this.currentPlan} searchDto={this.searchDto}/> : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
